/* TC - Tablero de control-  Presenta lista de Dominios*/
/* TC.ListaPFC - Lista de registros agrupados por PFC*/
/* TC.ListaPFC.Detalles - Tabla de información del PFC simple o agrupado*/

//*react- recursos
    import { useState, useEffect } from "react";
    import swal2 from "sweetalert2"; //npm install --save sweetalert2
    import ReactPaginate from "react-paginate";
    import { Panel, PanelGroup } from "rsuite";

//*componentes-utiles
    import CargandoSpin from "../../../../componentes/CargandoSpin";

//*clases 
    import '../../../../css/mdi.css'; 

//*imágenes
    import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from "react-icons/ai";    

//*archivos (imagenes y elementos necesarios para la rutina)
    import Detalles from "./TC.ListaPFC.Detalles"

//*api's (servicios y store)
    import catalogsServicio from "../../../../api/recursos/catalogs/catalogs.servicio"; 
    import catalogsStore    from "../../../../api/recursos/catalogs/catalogs.store"; 

    import dashboardStore from "../../../../api/recursos/dashboard/dashboard.store"; 

//*store's

//*datos
    import etiquetasSSC from "../../../../datos/json/etiquetasSSC.json";
    //import articulos from "../../../../datos/json/guidelines.json";
    
//*funciones

//*interfaces
    interface propsTCListaPFC {
        tokenStore: any;
        pfcDId: any,
        pfcDDominio:any,
        pfcArreglo: any;
        pfcAgrupado:any
        buscador: any;
        radioFiltroSelStore: any; //opción seleccionada del radio T-total, E-enviados, C-concluidos
        contaE: any; //contador de Enviados
        contaC: any; //contador de Concluidos
        recargaTC: any;
        recargaPaginaSSC: any;
        recargaPaginaSSC_Not: any;
    }

//*componente
 export default function TCListaPFC(props: propsTCListaPFC) {  
    //*api store
        const { guardaGetAllDecisionStore, catDecisionesStore,
                generaObjErrorCatalogsStore } =  
            catalogsStore((state:any) =>( { 
                guardaGetAllDecisionStore: state.guardaGetAllDecisionStore,
                catDecisionesStore: state.catDecisionesStore,
                generaObjErrorCatalogsStore: state.generaObjErrorCatalogsStore
        }));

        const { cambiaPfcDominioStore } =  
            dashboardStore((state:any) =>( { 
                cambiaPfcDominioStore: state.cambiaPfcDominioStore
        }));

    //*store's
     
    //*datos

    //*constantes y variables
        let eti = etiquetasSSC.TC;
        let x0, x1, x1a, x2, x3 = '';
        
    //*useState
        const [swRecarga, setSwRecarga] = useState(false); //usado para remasterizar página padre
        const [swRecargaListaPFC, setSwRecargaListaPFC] = useState(false); //usado para remasterizar página padre
        const [cargandoSpin,setCargandoSpin] = useState(false);
      
        //Buscador por medio del input de TC -  trae el valor del input en props.pfcAgrupado
        const [pfcAgrupadoBusqueda, setPfcAgrupadoBusqueda] = useState(props.pfcAgrupado);
        const [dominio, setDominio] = useState('');
        const [radioSel, setRadioSel] = useState(props.radioFiltroSelStore);

    //*useEffect
        useEffect(()=> { 
            //console.log('Carga TC.ListaPFC' );
            //console.log('-----buscador: ', props.buscador);
            //console.log('radioFiltroSelStore',props.radioFiltroSelStore)
            let x = 'divpanelDominio_' + props.pfcDId
            setDominio(x);
            //console.log('dominio:', dominio);
            window.scrollTo({top:0});  
        },[]);

        useEffect(()=> { //Carga cátalogo "Decisiones"- llama API - Catalogs/GetAllDecision
            setCargandoSpin(true); 
            catalogsServicio.cargaGetAllDecision(props.tokenStore)
            .then((response:any) => {
                if (response.status==200){  //revisa si hay error
                    guardaGetAllDecisionStore(response.data).then( function(datos:any) { 
                    ////console.log('cargo catDecisionesStore:', datos)
                    })
                }
                setCargandoSpin(false);   
            })
            .catch((ex) => { 
                //console.log ("--catch - ex (GetAllDecision): ", ex);
                generaObjErrorCatalogsStore(ex.response, true, '', '', 'TC-Catalogs/GetAllDecision');
                setCargandoSpin(false);   
            })
        },[]);

        useEffect(()=> { // uso este puente para recargar elementos del front
            //console.log('rederizando............');
            //console.log('-----buscador: ', props.buscador);
            //console.log('pfcFiltado: ', props.pfcAgrupado);
            //if (props.radioFiltroSelStore=='T') { const itemsPerPage = 10;}
            const dataPfcStore =  props.pfcAgrupado;
            setSwRecargaListaPFC(!swRecargaListaPFC);
        },[swRecarga]);

        useEffect(()=> { // uso este puente para recargar elementos del front
            //console.log('rederizando por cambio de props.buscador............');
            cargaBusqueda();
            //console.log('-----buscador: ', props.buscador);
            setSwRecargaListaPFC(!swRecargaListaPFC);
        },[props.buscador]);
        

    //*funciones
        const recargaPaginaSSC = () => { props.recargaPaginaSSC() } //ejecuta la función que esta TC y de ahí en Contenido que llama a la renderización de PaginaSSC

        const recargaPaginaSSC_Not = () => { props.recargaPaginaSSC_Not() } //ejecuta la función que esta TC y de ahí en Contenido que llama de PaginaSSC recargar el api de notificaciones para la campana

        const recargaTC = () => {  props.recargaTC() } //ejecuta la función que esta TC

        const recargaTCListaPFC = () => {  // con esto ejecuto un useEffect, lo uso para renderizar el front 
            setSwRecarga(!swRecarga);
        }

        const cargaBusqueda = () => {    
            const value = props.buscador;
            let filtered = []
            if (value !=''){
                filtered= props.pfcAgrupado.filter((filtro:any) => filtro.pfcNombre.toLowerCase().includes(value.toLowerCase()));  
                //console.log('cargaBusqueda filtered:', filtered);
                setPfcAgrupadoBusqueda(filtered);//regresa llos filtrados
            }
            else { setPfcAgrupadoBusqueda(props.pfcAgrupado) }
        };

        const abreCierraPFC = (idpfcA:any) => { //opciones liga-verFichaCompleta , boton-registra lee el contenido de la propuesta 
            cambiaPfcDominioStore(props.pfcDId, idpfcA, null, 'abreCierraPFC');
            setSwRecarga(!swRecarga)
        }

    //paginación: constante para el manejo de la 
        const dataPfcStore =  props.pfcAgrupado;
        const [pfcAgrupadoPaginado, setPfcAgrupadoPaginado] = useState([]);  //elementos mostrados según páginación
        const [pageCount, setPageCount] = useState(0);  //contabilidad de la página
        const [itemOffset, setItemOffset] = useState(0);  //desplazamiento 
        const itemsPerPage = 10;   //número de elementos a mostrar      

       //páginación: se ejectura al cambio de un elementos (al click en los botones)
        useEffect(() => { 
            //console.log('1.....entro a useEffect paginación..', props.radioFiltroSelStore)
            const endOffset = itemOffset + itemsPerPage;
            setPfcAgrupadoPaginado(dataPfcStore.slice(itemOffset, endOffset));
            setPageCount(Math.ceil(dataPfcStore.length / itemsPerPage));
            //setSwRecarga(!swRecarga);
            //console.log('-----::dataPfcStore', dataPfcStore);
            //console.log('-----::pfcAgrupadoPaginado', pfcAgrupadoPaginado);
          }, [itemOffset, itemsPerPage, dataPfcStore, props.radioFiltroSelStore]);

         useEffect(()=>{ 
            //console.log('2....entro a cambio de props.radioFiltroSelStore...........', props.radioFiltroSelStore);
            const dataPfcStore =  props.pfcAgrupado;
            const itemsPerPage = 10;
            setPageCount(Math.ceil(dataPfcStore.length / itemsPerPage));
            setItemOffset(0);
            setSwRecarga(!swRecarga);    
        },[props.radioFiltroSelStore]);

        //useEffect(()=>{ 
            //window.scrollTo({top:0});  
            //const element = document.getElementById(dominio);
            //element?.scrollIntoView(true) ;
        //},[pfcAgrupadoPaginado]); //páginación

        const clickPaginacion = (event: any) => {  //paginación: se ejecuta cuando se da un click en los elementos de páginación (botones)
            //console.log("dominio--------", dominio);
            const newOffset = (event.selected * itemsPerPage) % dataPfcStore.length;
            //console.log("newOffset--------", newOffset);
            setItemOffset(newOffset);
            setSwRecarga(!swRecarga);
            const element = document.getElementById(dominio);
            element?.scrollIntoView(true) ;
        };
    //termina paginación

    const encabezadoPFC = () => {
        return (
          <>
            <br/>
            {/* <p>...{props.pfcDDominio}</p>
            <p>...{pfcAgrupadoBusqueda.length }</p> */}
            { props.radioFiltroSelStore=='T' &&
                (<> <h5 className='color-azul4 background-color-azul2'>Proceso/Frecuencia/Ciclo</h5> </>)
            } 
            {(props.radioFiltroSelStore=='E' && props.contaE>0) &&
                (<> <h5 className='color-azul4 background-color-azul2'>Proceso/Frecuencia/Ciclo</h5> </>)
            } 
            {(props.radioFiltroSelStore=='C' && props.contaC>0) &&
                (<> <h5 className='color-azul4 background-color-azul2'>Proceso/Frecuencia/Ciclo</h5> </>)
            } 
            <br/>
          </> 
        )
    }

    //*vista
     return (
      <>
       
        {/* lista de pfc que son del dominio*/}
            <div className='padding-left-3r'>
                {/* props.buscador ::::: {props.buscador} -<br/> 
                no. registros en pfcAgrupadoBusqueda:::: {pfcAgrupadoBusqueda.length}<br/>
                no. registros en pfcAgrupado.:::: {props.pfcAgrupado.length}<br/>
                props.radioFiltroSelStore:::: {props.radioFiltroSelStore}<br/>
                props.contaE:::: { props.contaE}<br/>
                props.contaC:::: { props.contaC}<br/>
                pageCount::::::{pageCount}<br/>
 */}
                {/*  subencabezado:  Proceso/Frecuencia/Ciclo */}
                { props.buscador != '' && (<> {encabezadoPFC()} </>) }

                {/* Tenemos 2 listas:
                    pfcAgrupadoBusqueda: trae los registros filtrados según la busqueda. Se presenta si props.buscador != ''
                    pfcAgrupadoPaginado: trae los registros completos paginados de 10 en 10. Se presenta si props.buscador == ''
                */}
                { props.buscador != ''
                    ? (<>
                        {/* lista de pfc filtrada por la busqueda*/}
                        <div>
                            { pfcAgrupadoBusqueda?.map((pfc:any, indexpfcAgrupadoBusqueda:any) => (
                                //acrónimo/frecuencia/ciclo & nombre del proceso
                                (x2 = 
                                  (<>
                                    <div id={`divpanelBuscador_${pfc.id}`}>
                                       {/*   <p>...{props.radioFiltroSelStore}</p> */}
                                       { props.radioFiltroSelStore =='T' &&
                                            (<>
                                                <span id="panelDes2">
                                                    <span className=' color-secundario'> {pfc.pfcNombre}</span><br/>
                                                    <span className='font-size-12' > {pfc.arreglo[0].processname} </span>
                                                </span>
                                            </>)
                                        }
                                        { props.radioFiltroSelStore =='C' &&
                                            (<>
                                                <span id="panelDes2">
                                                    <span className=' color-secundario'> {pfc.pfcNombre}</span><br/>
                                                    <span className='font-size-12' > {pfc.arreglo[0].processname} </span>
                                                    <span className="h6 color-verde2">
                                                            &nbsp;<i className="mdi mdi mdi-email-check-outline"></i>Concluido
                                                    </span>
                                                </span>
                                            </>)
                                        }
                                        { props.radioFiltroSelStore =='E' &&
                                            (<>
                                                <span id="panelDes2">
                                                    <span className=' color-secundario'> {pfc.pfcNombre}</span><br/>
                                                    <span className='font-size-12' > {pfc.arreglo[0].processname} </span>
                                                    <span className="h6 color-naranja2">
                                                            &nbsp;<i className="mdi mdi-file-document"></i>En proceso de documentación
                                                    </span>
                                                </span>
                                            </>)
                                        }
                                        
                                        <hr />
                                    </div>   
                                  </>)
                                ),
                                (<>
                                  <PanelGroup accordion  >
                                    { props.radioFiltroSelStore == 'T' &&
                                        (<>
                                            <Panel
                                                header={x2}
                                                key={pfc.key}
                                                id={pfc.id}
                                                collapsible={pfc.abierto}
                                                onClick={() => abreCierraPFC(pfc.id)}
                                                >
                                            </Panel> 

                                        </>)
                                        
                                    }
                                    { (props.radioFiltroSelStore == 'E' && pfc.e > 0) &&
                                        (<Panel
                                            header={x2}
                                            key={pfc.key}
                                            id={pfc.id}
                                            collapsible={pfc.abierto}
                                            onClick={() => abreCierraPFC(pfc.id)}
                                            >
                                        </Panel> )
                                    }
                                    { (props.radioFiltroSelStore == 'C' && pfc.c > 0) &&
                                        (<Panel
                                            header={x2}
                                            key={pfc.key}
                                            id={pfc.id}
                                            collapsible={pfc.abierto}
                                            onClick={() => abreCierraPFC(pfc.id)}
                                            >
                                        </Panel> )
                                    }
                                    {pfc.abierto && 
                                        (<>
                                        <Detalles
                                            key={pfc.id}
                                            tokenStore={props.tokenStore}
                                            catDecisionesStore={catDecisionesStore}
                                            pfcDId = {props.pfcDId}
                                            pfcAId = {pfc.id}
                                            pfcNombre= {pfc.pfcNombre}
                                            pfcArreglo = {pfc.arreglo}
                                            recargaTC = {recargaTC}
                                            recargaTCListaPFC = {recargaTCListaPFC}
                                            recargaPaginaSSC = {recargaPaginaSSC}
                                            recargaPaginaSSC_Not  = {recargaPaginaSSC_Not}
                                        /> 
                                        <hr />
                                        </>)   
                                    }  
                                  </PanelGroup> 
                                </>)
                            ))}  
                        </div> 
                      </>)
                    : (<>
                        {/* lista de pfc */}
                        <div>
                            { pfcAgrupadoPaginado?.map((pfc:any, indexPFC:any) => (
                                //acrónimo/frecuencia/ciclo & nombre del proceso
                                (x2 = 
                                (<>
                                
                                  <div id={`divpanelPFC_${pfc.id}`}>
                                    <span id="panelDes2">
                                        <span className=' color-secundario'> {pfc.pfcNombre}</span><br/>
                                        <span className='font-size-12' > {pfc.arreglo[0].processname} </span>
                                        { props.radioFiltroSelStore !='T' &&
                                          (<>
                                            { props.radioFiltroSelStore =='E' &&
                                              (<>
                                                { pfc.e > 0 &&
                                                    (<>
                                                    <span className="h6 color-naranja2">
                                                        &nbsp;<i className="mdi mdi-file-document"></i>En proceso de documentación
                                                    </span>
                                                    </>)
                                                }
                                              </>)   
                                            }
                                            { (props.radioFiltroSelStore =='C' && pfc.c > 0) &&
                                                (<span className="h6 color-verde2">
                                                    &nbsp;<i className="mdi mdi mdi-email-check-outline"></i>Concluido
                                                </span>)
                                            }
                                          </>)
                                        }
                                    </span>
                                    <hr />
                                  </div> 
  
                                </>)
                                ),
                                (<>
                                <PanelGroup accordion  >
                                    { props.radioFiltroSelStore == 'T' &&
                                        (<Panel
                                            header={x2}
                                            /* eventKey={index} usado cuando se quiere un solo panel abierto */
                                            key={pfc.key}
                                            id={pfc.id}
                                            collapsible={pfc.abierto}
                                            onClick={() => abreCierraPFC(pfc.id)}
                                            >
                                        </Panel> )
                                    }
                                    { (props.radioFiltroSelStore == 'E' && pfc.e > 0) &&
                                        (<Panel
                                            header={x2}
                                            key={pfc.key}
                                            id={pfc.id}
                                            collapsible={pfc.abierto}
                                            onClick={() => abreCierraPFC(pfc.id)}
                                            >
                                        </Panel> )
                                    }
                                    { (props.radioFiltroSelStore == 'C' && pfc.c > 0) &&
                                        (<Panel
                                            header={x2}
                                            key={pfc.key}
                                            id={pfc.id}
                                            collapsible={pfc.abierto}
                                            onClick={() => abreCierraPFC(pfc.id)}
                                            >
                                        </Panel> )
                                    }
                                    {pfc.abierto && 
                                      (<>
                                        <Detalles
                                            key={pfc.id}
                                            tokenStore={props.tokenStore}
                                            catDecisionesStore={catDecisionesStore}
                                            pfcDId = {props.pfcDId}
                                            pfcAId = {pfc.id}
                                            pfcNombre = {pfc.pfcNombre}
                                            pfcArreglo = {pfc.arreglo}
                                            recargaTC = {recargaTC}
                                            recargaTCListaPFC = {recargaTCListaPFC}
                                            recargaPaginaSSC = {recargaPaginaSSC}
                                            recargaPaginaSSC_Not  = {recargaPaginaSSC_Not}
                                        /> 
                                        <hr />
                                      </>)   
                                    }  
                                </PanelGroup> 
                                </>)
                            ))}  
                        </div> 

                        {/* paginación: elemento visuales  */}

                        {/* <p>props.radioFiltroSelStore--{props.radioFiltroSelStore}</p>
                        <p>pageCount--{pageCount}</p> */}
                        { pageCount > 1  && 
                            (<>
                              <ReactPaginate
                                //2.1
                                breakClassName="..."
                                nextLabel={ <AiOutlineDoubleRight style={{ fontSize: 18, width: 150, verticalAlign: "middle", marginLeft: "-10px",}} /> }          
                                pageRangeDisplayed={2}
                                pageCount={pageCount}
                                previousLabel={ <AiOutlineDoubleLeft style={{ fontSize: 18, width: 150, verticalAlign: "middle",  marginLeft: "10px", }} /> }
                                renderOnZeroPageCount={null}
                                containerClassName="pagination"
                                pageLinkClassName="page-num"
                                previousLinkClassName="page-num"
                                nextLinkClassName="page-num"
                                activeClassName="active"
                                disabledLinkClassName="gray"
                                onPageChange={clickPaginacion}
                              />
                            </>) 
                        }
                      </>)
                }

            </div>

        {/* ventana de carga con spin que se abre mientras lee el api */}
            { cargandoSpin && <CargandoSpin /> }
      </>
     );
 }
